import React from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import EACheckbox from "../Checkbox/EACheckbox";
import useConsentGroup from "./useConsentGroup";
import { ConsentItem } from "./types";
import "./ConsentGroup.scss";

interface IProps {
  items: ConsentItem[];
  control: any;
  errors: any;
  setValue: any;
  onSelectAll?: (checked: boolean) => void;
  extraChecksForSelectAll?: boolean[];
}

const ConsentGroup: React.FC<IProps> = ({
  items,
  control,
  errors,
  setValue,
  onSelectAll,
  extraChecksForSelectAll,
}) => {
  const { t } = useTranslation();
  const { isAllChecked, showSelectAll, handleSelectAll } = useConsentGroup({
    items,
    control,
    setValue,
    onSelectAll,
    extraChecksForSelectAll,
  });

  return (
    <div className="consent-group">
      {showSelectAll && (
        <EACheckbox
          name="selectAll"
          checked={isAllChecked}
          onChange={handleSelectAll}
          label={t("zaznacz_wszystkie_zgody")}
        />
      )}

      {items.map((item) => (
        <Controller
          key={item.fieldName}
          name={item.fieldName}
          control={control}
          rules={{ required: item.required }}
          render={({ field }) => (
            <EACheckbox
              name={item.fieldName}
              checked={!!field.value}
              field={field}
              errors={errors}
              label={item.label}
            />
          )}
        />
      ))}
    </div>
  );
};

export default ConsentGroup;
